import { render } from "./image_delete.svg?vue&type=template&id=7051145e"
const script = {}

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__